import React from 'react';
import styles from './Grid.module.css';

export const Grid: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles.grid}>{children}</div>
); 